module.exports = __webpack_public_path__ + "static/media/empty.47ed2d91.png";